
import { Component } from 'vue-property-decorator';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import { EVENTS } from '@/author/constants';
import { LOCK_CONST } from '@/constants';
import Bookmark from '@/models/Bookmark';
import { mixins } from 'vue-class-component';
import Scorm from '@bob-the-builder/kb4-scorm-client';
import { ThemeConfModule } from '@/store/modules/theme';
import kb4ScormClientHelper from '@/utils/kb4ScormClientHelper';

const AppState = getModule(AppModule, store);
const ThemeStore = getModule(ThemeConfModule, store);

@Component
export default class BaseComponent extends mixins(Scorm) {

  created(){
    this.initScorm();
    if(ThemeStore.getTheme) this.setThemeConf(ThemeStore.getTheme);
  }

  initScorm() {
    this.init(ThemeStore.getScormOptions);
  }

  get getSavedData(): any {
    return AppState.getSavedData;
  }

  get getCurrentSlide(): string {
    return AppState.currentSlide;
  }
  get getLockMode(): number {
    return AppState.getLockMode;
  }

  lockForward() {
    AppState.setLock(LOCK_CONST.FORWARD_LOCKED);
  }

  unlock() {
    AppState.setLock(LOCK_CONST.UNLOCKED);
  }

  lock() {
    AppState.setLock(LOCK_CONST.TOTALLY_LOCKED);
  }

  saveData(data: any) {
    if(AppState.getIsScenarioPageActive) return;
    const bookmark = this.getBookmark();
    const newBookmark: Bookmark = { ...bookmark, lastSlideState: data };
    this.setBookmark(newBookmark);
    AppState.saveData(data);
  }

  chooseAnswer(right: boolean) {
    AppState.chooseAnswer(right);
  }

  emitRefreshed() {
    this.emitEvent(EVENTS.REFRESHED);
  }

  emitCompleted() {
    this.emitEvent(EVENTS.COMPLETED);
  }

  isMobileApp() {
    return kb4ScormClientHelper.isMobileApp();
  }

  emitEvent(eventName: string) {
    this.$parent?.$emit(eventName);
  }

  focusOnSlideTitle(){
    setTimeout(() => {
      let slideTitle = document.getElementById('slideTitle');
      if(slideTitle) slideTitle.focus();
    }, 200);
  }
}
